import type * as Types from '@precon-tools-suite-by-shared/precon-graphql-types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CurrentUserTeamsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserTeamsQuery = {
  __typename: 'Query',
  me?: {
    __typename: 'AccessToken',
    user?: {
      __typename: 'User',
      id: string,
      teams?: {
        __typename: 'User_TeamConnection',
        edges?: Array<{
          __typename: 'User_TeamEdge',
          cursor: string,
          node: {
            __typename: 'Team',
            id: string,
            uuid: string,
            name?: {
              __typename: 'Name',
              full?: string | null,
              short?: string | null
            } | null
          }
        } | null> | null
      } | null
    } | null
  } | null
};


export const CurrentUserTeamsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserTeams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"name"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full"}},{"kind":"Field","name":{"kind":"Name","value":"short"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserTeamsQuery, CurrentUserTeamsQueryVariables>;